'use strict';

const React = require('react');
const classnames = require('classnames');
const MenuLink = require('./MenuLink');
const PrimaryMenu = ({model, show}) => {

	const primaryItems = model.destinationLinks;
	const secondaryItems = model.infoPageLinks;
	const primaryMiddle = Math.ceil(primaryItems.length / 2);
	const classType = classnames({
		'svtse_menu__navigation': true,
		'svtse_menu__navigation--show' : show
	});

	return (
		<nav className={classType} role="navigation" id="svtse_a11y-primary-list">
			<hr className="svtse_menu__hr" />
			<ul className="svtse_menu__primary-list">


			{primaryItems.map((link, index) => {
				const classNames = classnames({
					'svtse_menu__primary-list__item' : true,
					['svtse_menu__primary-list__item--cb-' + index] : index === primaryMiddle,
					'svtse_menu__primary-list__item--second-col' : index >= primaryMiddle
				});

				return (
					<li className={classNames} key={link.id || index}>
						<MenuLink className="svtse_menu__item-link" model={link}>{link.title}</MenuLink>
					</li>
				);
			})}
			{secondaryItems.map((link, index) => {
				return (
					<li key={index} className="svtse_menu__primary-list__item-secondary">
						<MenuLink className="svtse_menu__item-link" model={link}>{link.title}</MenuLink>
					</li>
				);
			})}
			</ul>
		</nav>
	);
};

PrimaryMenu.propTypes = {
	model: React.PropTypes.object.isRequired,
	show: React.PropTypes.bool
};

module.exports = PrimaryMenu;



/** WEBPACK FOOTER **
 ** ./app/components/menu/PrimaryMenu.js
 **/